import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'

import "./i18n/config";

import "simplebar-react/dist/simplebar.min.css";

import "./styles/index.css";

// Suppress console logs in production-like environments
if (['prod', 'qa', 'uat'].includes(import.meta.env.MODE)) {
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
  console.trace = () => {};
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
